import type { Asset } from '@b2ag/contentful'

export const assetDtoToUrl = (dto?: Asset): string | undefined => {
  const output = dto?.fields.file?.url?.toString()
  return output && `${!output.startsWith('http') ? 'https:' : ''}${output}`
}
